import 'css-chunksrc/client/pages/planzoneParametersPage/timesheetDeadline/styles.scss';export default {
  "timesheetDeadline": "_timesheetDeadline_31c64_1",
  "description": "_description_31c64_6",
  "content": "_content_31c64_11",
  "successMessage": "_successMessage_31c64_17"
};